import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPencil,
  faPlus,
} from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import useRedirectUrlWithCacheKey from '@hooks/useRedirectUrlWithCacheKey'
import { generateUrls } from '@hooks/useArtwork'
import { UseCampaignQuoteItemPayload } from '@hooks/useCampaignQuoteItem'

interface ArtworkButtonProps {
  campaignQuoteItemPayload: UseCampaignQuoteItemPayload,
}

const ArtworkButton = (props: ArtworkButtonProps) => {
  const {
    campaignQuoteItemPayload: {
      artwork,
      campaignQuoteItem,
      canCreateArtwork,
      requiredItems,
    },
  } = props

  // @ts-expect-error TS2322
  const { redirectUrl } = useRedirectUrlWithCacheKey([campaignQuoteItem.campaign_quote_id])

  if (!requiredItems.artwork || !canCreateArtwork){
    return null
  }

  // @ts-expect-error TS2339
  const urls = generateUrls({ campaign_quote_item_id: campaignQuoteItem.id, id: artwork.id }, {
    includeRedirect: true,
    redirectUrl,
  })

  return (
    <Button
      // @ts-expect-error TS2322
      as="a"
      buttonStyle="secondaryUtility"
      // @ts-expect-error TS2339
      icon={<FontAwesomeIcon icon={artwork.id ? faPencil : faPlus} />}
      // @ts-expect-error TS2339
      href={artwork.id ? urls.editArtworkUrl : urls.createArtworkUrl}
      size="medium"
    >
      {/*
       // @ts-expect-error TS2339 */}
      {artwork.id ? 'Edit' : 'Create'} Artwork
    </Button>
  )
}

export default ArtworkButton
